import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button } from 'react-bootstrap';
import { updateUserConsent, terminatedUser } from "../api";
import * as action from '../actions'
import Header from "../components/Header";
import "../styles/settings.css";
import useToastify from "../hooks/useToastify";

export default function PrivacySettings(props) {
  const user = useSelector(state => state?.user)
  const { notifySuccess, notifyError } = useToastify();
  const dispatch = useDispatch();
  const agreement = useSelector(state => state?.user?.agreement)

  const [open, setOpen] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(agreement?.privacyPolicy);
  const [imageCheck, setImageCheck] = useState(agreement?.useImagesForTrainning);
  const [communicationCheck, setCommunicationCheck] = useState(agreement?.consentForMarketing);

  const resetAgreementCheck = () => {
    setImageCheck(agreement?.useImagesForTrainning)
    setCommunicationCheck(agreement?.consentForMarketing)
  }

  const saveAgreementUpdate = async () => {
    const payload = {
      privacyPolicy: privacyPolicy,
      privacyPolicyAgreedOn: new Date(),
      useImagesForTrainning: imageCheck,
      useImagesForTrainningAgreedOn: new Date(),
      consentForMarketing: communicationCheck,
      consentForMarketingAgreedOn: new Date(),
      timezone: user?.timezone,
    };
    const updateUserConsentResp = await updateUserConsent(user.uid, payload);
    dispatch(action.updateUser({...user, ...updateUserConsentResp.user}));
    notifySuccess(updateUserConsentResp.message);
  }

  const continueTerminated = async () => {
    const terminatedUserResp = await terminatedUser(user.uid);
    if(terminatedUserResp.success) {
      dispatch(action.logoutUser());
      props.history.push('/login');
    } else {
      notifyError(terminatedUserResp.message)
    }
  }

  const onChangePrivacy = () => {
    if(agreement?.privacyPolicy) {
      setOpen(true);
    } else {      
      setPrivacyPolicy(!privacyPolicy)
    }
  }

  useEffect(() => {
    document.title = "Privacy Settings";
  }, []);

  return (
    <div className="container" data-testid="settings-container">
      <div className="main settings mt-3">
        <Header />
        <p className="heading">Privacy Settings</p>
        <div className="wrapper">
          <div className="agreement-container">
            <div className="use-images-agreement">
              <input
                type="checkbox"
                id="privacyPolicy"
                data-testid="privacyPolicy"
                className="privacy-policy-input"
                checked={privacyPolicy}
                onChange={onChangePrivacy}
              />
              <div>I agree to the iSelfie privacy policy.</div>
            </div>
            <div className="use-images-agreement">
              <input
                type="checkbox"
                id="useImagesForTrainning"
                data-testid="useImagesForTrainning"
                className="use-images-agreement-input"
                checked={imageCheck}
                onChange={() => setImageCheck(!imageCheck)}
              />
              <div>I agree to donate my images for iSelfie service improvements.</div>
            </div>
            <div className="use-communication-agreement">
              <input
                type="checkbox"
                id="consentForMarketing"
                data-testid="consentForMarketing"
                className="use-communication-agreement-input"
                checked={communicationCheck}
                onChange={() => setCommunicationCheck(!communicationCheck)}
              />
              <div>I opt-in to marketing emails.</div>
            </div>
          </div>
          <div className="text-left mt-2">
            <div><span>For any privacy inqueries, please send an email to <a href="mailto:privacy@aiztechlabs.com" className="font-weight-bold">privacy@aiztechlabs.com</a></span></div>
            <div><span>Check our <a className="font-weight-bold" href='https://www.aiztechlabs.com/privacy' target='_blank'>privacy policy</a></span></div>
          </div>
        </div>

        {(privacyPolicy !== agreement?.privacyPolicy || imageCheck !== agreement?.useImagesForTrainning || communicationCheck !== agreement?.consentForMarketing) && (
          <div className="setting-cta">
            <div className="cancel-cta">
              <button className="cancel-cta-button" data-testid="cancel-cta-button" onClick={resetAgreementCheck}>
                Cancel
              </button>
            </div>
            <div className="save-cta">
              <button className="save-cta-button" data-testid="save-cta-button" onClick={saveAgreementUpdate}>
                Save
              </button>
            </div>
          </div>
        )}
        <Modal animation={false} show={open} onHide={() => setOpen(false)} centered className='warning_modal' data-testid="warning_modal">
            <Modal.Header>
                <Modal.Title>Privacy Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body className="body">
                <p>If you do not agree with our privacy policy, we cannot provide our services to you. By clicking on “Continue”, your access to the service will be limited.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' id='cancel' data-testid="cancel" onClick={() => setOpen(false)}>Cancel</Button>
                <Button variant='primary' id='continue' data-testid="continue" onClick={continueTerminated}>Continue</Button>
            </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
